import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import { BASE_UPLOADS } from "../../../utils/constants";

const ProfileIcon = () => {
	const [dropdownOpen, setDropdownOpen] = useState(false);
	const dropdownRef = useRef(null);
	const navigate = useNavigate();
	const { user, logout } = useContext(AuthContext);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (
				dropdownRef.current &&
				!dropdownRef.current.contains(event.target)
			) {
				setDropdownOpen(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);
	const pageNavigate = (id) => {
		navigate(`/${id}`);
	};

	const toggleDropdown = () => {
		setDropdownOpen((prev) => !prev);
	};

	const handleOptionClick = async (option) => {
		setDropdownOpen(false);
		if (option === "Logout") {
			try {
				logout();
				pageNavigate("");
			} catch (error) {
				console.error(error);
			}
		} else if (option === "Profile") {
			switch (user?.role) {
				case "student":
					navigate("/studentprofile");
					break;
				case "teacher":
					navigate("/teachersProfile");
					break;
				default:
					navigate("/");
			}
		} else if (option === "Settings") {
			navigate("/settings");
		}
	};
	return (
		<>
			<button
				onClick={toggleDropdown}
				className="bg-black text-white text-xs rounded-full relative"
			>
				<img
					src={
						user?.profilePic
							? `${BASE_UPLOADS}/profile/${user?._id}/${user?.profilePic}`
							: "./images/8.jpg"
					}
					alt="Student"
					className="w-10 h-10 rounded-full shadow-lg ring-4 ring-blue-200 transform hover:scale-105 transition-transform duration-300"
				/>
			</button>
			{/* Dropdown Menu */}
			{dropdownOpen && (
				<div
					ref={dropdownRef}
					className="absolute top-16 right-0 bg-white shadow-lg rounded-lg p-3 w-48 text-gray-800"
				>
					<button
						onClick={() => handleOptionClick("Profile")}
						className="block w-full text-left px-4 py-2 hover:bg-gray-100 rounded"
					>
						Profile
					</button>
					<button
						onClick={() => handleOptionClick("Settings")}
						className="block w-full text-left px-4 py-2 hover:bg-gray-100 rounded"
					>
						Settings
					</button>

					<button
						onClick={() => handleOptionClick("Logout")}
						className="block w-full text-left px-4 py-2 text-red-500 hover:bg-gray-100 rounded"
					>
						Logout
					</button>
				</div>
			)}
		</>
	);
};

export default ProfileIcon;
